import http from "@http"

//列表  不分页
export function getDefectGradeAll(data) {
    return http({
        url: '/lskj-data/api/data/defectGrade/all',
        method: "post",
        data
    })
}
//列表  分页
export function getDefectGradeList(data) {
    return http({
        url: '/lskj-data/api/data/defectGrade/list',
        method: "post",
        data
    })
}

//查询单条
export function defectGradeById(data) {
    return http({
        url: `/lskj-data/api/data/defectGrade/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function defectGradeAdd(data) {
    return http({
        url: '/lskj-data/api/data/defectGrade/add',
        method: "post",
        data
    })
}

//修改
export function updeteDefectGrade(data) {
    return http({
        url: `/lskj-data/api/data/defectGrade`,
        method: "put",
        data
    })
}
//删除
export function deleteDefectGrade(data) {
    return http({
        url: `/lskj-data/api/data/defectGrade?ids=${data.ids}`,
        method: "delete",
        data
    })
}